module.exports = {
	env: 'production',
	apiUrl: '',
	successRedirectionFallback: "https://yodaforex.cloud",
	authConfig: {
		sessionTokenCookieDomain: ".yodaforex.cloud",
		authUrl: "/v2/auth/token"
	}
}
